import React from 'react'
import PropTypes from 'prop-types'
import { compose, setDisplayName, shouldUpdate } from 'recompose'
import { noop, isNil, isEqual } from 'lodash'

import { FormBlock } from 'components/formBlock/FormBlock'
import { Checkbox } from 'components/checkbox/Checkbox'

const FormCheckboxView = ({
  field,
  title,
  isReadonly,
  isDisabled,
  isRequired,
  showErrorText,
  onChange,
  handleFieldChange,
  className,
  ...props
}) => {
  const handleChange = onChange ? onChange : handleFieldChange ? handleFieldChange(field.name) : noop
  const isRequiredField = isNil(isRequired) ? field.isRequired : isRequired

  return (
    <FormBlock
      readonlyView={field.value ? 'Yes' : 'No'}
      isReadonly={!!isReadonly}
      isRequired={!!isRequiredField}
      className={className}>
      <Checkbox
        textLabel={title}
        onChange={handleChange}
        checked={!!field.value || false}
        error={field.error}
        disabled={isDisabled}
        showErrorText={showErrorText}
        {...props}
      />
    </FormBlock>
  )
}

FormCheckboxView.propTypes = {
  field: PropTypes.object.isRequired,
  title: PropTypes.node,
  isDisabled: PropTypes.bool,
  isReadonly: PropTypes.bool,
  isRequired: PropTypes.bool,
  showErrorText: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  handleFieldChange: PropTypes.func,
}

export const FormCheckbox = compose(
  setDisplayName('FormCheckbox'),
  shouldUpdate((props, nextProps) => !isEqual(props, nextProps)),
)(FormCheckboxView)
